<lib-bo-auth-input
  [inputId]="inputId()"
  [label]="label()"
  [placeholder]="placeholder()"
  [inputType]="inputType()"
  [autocomplete]="autocomplete()"
  [hasSuffix]="true"
  [control]="control()"
  [customErrorMessage]="customErrorMessage()"
>
  <button
    type="button"
    class="bo-auth-password-toggle"
    [attr.aria-pressed]="showPassword()"
    [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
    (click)="togglePassword()"
  >
    @if (showPassword()) {
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </svg>
    } @else {
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    }
  </button>
  <span suffix></span>
</lib-bo-auth-input>
